export default function createGlobalStoreService(jokiInstance) {
    const serviceId = "GlobalStoreService";
    const joki = jokiInstance;

    function messageHandler(event) {
        switch (event.key) {
            case "set":
                if (event.to === serviceId) {
                    set(event.body.key, event.body.value);
                }
                break;
            case "get":
                if (event.to === serviceId) {
                    return get(event.body.key);
                }
                break;
            case "delete":
                if (event.to === serviceId) {
                    del(event.body.key);
                }
                break;
            case "has":
                if (event.to === serviceId) {
                    return get(event.body.key) !== undefined;
                }
                break;
            case "getState":
                if (event.to === serviceId) {
                    return MapToObject();
                }
                break;
            case "initialize":
                if (event.to === serviceId) {
                    initialize(event.body);
                }
                break;
            case "clearAll":
                if (event.to === serviceId) {
                    clearAllData();
                }
                break;
            default:
                break;
        }
    }

    /**
     * Initialization event does not trigger anything. It is currently only used in testing.
     * @param {*} keyValuePairs 
     */
    function initialize(keyValuePairs) {
        if(Array.isArray(keyValuePairs)) {
            keyValuePairs.forEach(pair => {
                localStorage.setItem(pair[0], pair[1]);
            });
        }
    }


    function clearAllData() {
        localStorage.clear();
    }

    function set(key, value) {
        if(value === 'null' || value === 'undefined') {
            value = null;
        }
        localStorage.setItem(key, value);
        triggerServiceUpdate();
        triggerValueUpdate(key, value);
    }

    function get(key) {
        const value = localStorage.getItem(key);
        if (value !== null && value !== 'null' && value !== 'undefined') {
            return localStorage.getItem(key);
        }
        return undefined;
    }

    function del(key) {
        if (localStorage.getItem(key)) {
            localStorage.removeItem(key);
            triggerServiceUpdate();
            triggerValueDelete(key);
        }
    }

    function triggerServiceUpdate() {
        joki.trigger({
            from: serviceId,
            serviceUpdate: true,
            body: MapToObject(),
        });
    }

    function triggerValueUpdate(key, value) {
        joki.trigger({
            from: serviceId,
            key: "valueChanged",
            body: {
                key: key,
                value: value,
            },
        });
    }

    function triggerValueDelete(key) {
        joki.trigger({
            from: serviceId,
            key: "valueDeleted",
            body: {
                key: key
            },
        });
    }

    function MapToObject() {
        const obj = {};
        for(let i=0; i<localStorage.length;++i) {
            const key = localStorage.key(i);
            obj[key] = get(key);
        }
        return obj;
    }

    joki.addService({
        id: serviceId,
        fn: messageHandler,
    });
}
